import { GlobalAxios } from "./../axios/axios-config";
import {
  INewIntegrationRuleRelationshipGroup,
  IIntegrationRuleRelationshipGroup,
} from "../models/integration-rule-relationship-group";

const INTEGRATION_RULE_RELATIONSHIP_GROUP_ROUTE =
  process.env.REACT_APP_MAIN + "/api/v1/4uBusIntegrationRuleRelationshipGroup/";

export const createIntegrationRuleRelationshipGroup = (
  item: INewIntegrationRuleRelationshipGroup,
) => {
  return GlobalAxios.post(INTEGRATION_RULE_RELATIONSHIP_GROUP_ROUTE, item);
};

export const getIntegrationRuleRelationshipGroupById = (id: string) => {
  return GlobalAxios.get<IIntegrationRuleRelationshipGroup>(
    INTEGRATION_RULE_RELATIONSHIP_GROUP_ROUTE + id,
  );
};

export const updateIntegrationRuleRelationshipGroupById = ({
  item,
  id,
}: {
  item: INewIntegrationRuleRelationshipGroup;
  id: string;
}) => {
  return GlobalAxios.put(INTEGRATION_RULE_RELATIONSHIP_GROUP_ROUTE + id, item);
};
